const numOfDec = 2;

export const normalizePhone = (value: string) => value.replace(/[^\d]/g, '');

export const normalizeBirthYear = (
  value: string,
  previousValue: string | undefined,
) => {
  const currentYear = new Date().getFullYear();
  return (parseFloat(value) >= 0 && parseFloat(value) <= currentYear) ||
    value === ''
    ? value
    : previousValue;
};

function roundTo(num: number) {
  return Number(
    Math.round(Number(num + `e+${numOfDec}`)) + `e-${numOfDec}`,
  );
}

export const formatCurrencyToNumber = (value: string) => {
  const newValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
  return Number(newValue);
};

export const formatNumberToCurrency = (value: number) => {
  let newValue = String(roundTo(value));
  if (newValue.indexOf('.') < 0) {
    newValue += ',00';
  } else {
    const lengthOfPad = numOfDec - (newValue.length - newValue.indexOf('.') - 1);
    newValue = newValue.replace('.', ',').padEnd(newValue.length + lengthOfPad, '0');
  }
  return normalizeCurrency(newValue);
};

function normalizeNumber(n: any) {
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function normalizeCurrency(value: string | number) {
  let newValue = String(value);

  if (!newValue.length) {
    return;
  }

  if (newValue.endsWith('.')) {
    newValue = newValue.substring(0, newValue.lastIndexOf('.')) + ',';
  }

  if (newValue.indexOf(',') >= 0) {
    const decimal_pos = newValue.indexOf(',');

    let left_side = newValue.substring(0, decimal_pos);
    let right_side = newValue.substring(decimal_pos);

    left_side = normalizeNumber(left_side);
    right_side = normalizeNumber(right_side);
    right_side = right_side.substring(0, numOfDec);

    newValue = '€ ' + left_side + ',' + right_side;
  } else {
    newValue = normalizeNumber(newValue);
    newValue = '€ ' + newValue;
  }
  return newValue;
}
